import MatchHeight from '../helpers/element/matchHeight';

export function initMatchHeight() {
    const elems = document.querySelectorAll('.js-match-height');
    if (elems.length > 0) {
        new MatchHeight(elems);
    }
}
